import { cn } from '@/lib/utils';

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  isActive?: boolean;
  disabled?: boolean;
}

export const PaginationButton = ({
  children,
  className = '',
  isActive = false,
  disabled = false,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={cn(
        'border border-[#E4E9EE] w-[40px] h-[40px] rounded-lg flex items-center justify-center hover:bg-gray-50 cursor-pointer transition-colors font-medium text-[16px] tracking-[-0.3125px] leading-[24px]',
        isActive && 'bg-black text-white border-black hover:bg-black',
        !isActive && 'bg-white text-[#333]',
        disabled && 'opacity-50 cursor-not-allowed hover:bg-white',
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
